<template lang="html">
  <v-btn @click="exportKonversiNilai('tahun')" :loading="isLoading" color="error darken-4 white--text" rounded class="mr-0 mt-2">
    <span>
      <v-icon small left>mdi-file-pdf-box</v-icon>
      Download Konversi Nilai Angka Kredit
    </span>
  </v-btn>
</template>

<script>
import _ from 'lodash'
import store from "@/store"
import PenilaianService from "@/services/PenilaianService"

export default {
  props: {
    triwulan: {
      type: Number,
      required: true,
      validator(value) {
        return [0, 1, 2, 3, 4].includes(value);
      },
    },
  },
  data(){
    return {
      isLoading: false
    }
  },
  methods:{
    async exportKonversiNilai() {
      try {
        let current = store.state.user.current
        const response = current.year > 2023
          ? await PenilaianService.konversiAngkaKreditV2(this.triwulan)
          : await PenilaianService.konversiAngkaKredit(this.triwulan);
        this.redirectToDocument(response.data);
        this.showSnackbar(response.data.message, "success");
      } catch (err) {
        const message = err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Server sedang sibuk, silahkan coba beberapa saat lagi";
        this.showSnackbar(message, "error");
      } finally {
        this.isLoading = false;
      }
    },

    showSnackbar(message, color) {
      store.commit("snackbar/setSnack", { message, color })
    },

    redirectToDocument(data){
      let current = store.state.user.current;
      let url = "";
      let tipe = this.triwulan == 0 ? 'tahunan' : 'triwulan';
      let extra = this.triwulan == 0 ? '' : `&twn=${this.triwulan}`;
      let crc = current.year >= 2024 ? data.data.crc : data.crc;
      let dataType = data.data.tipe_data1_or_data2;

      url = `${process.env.VUE_APP_API_URL}/export-pdf/1/3/?tipe=${tipe}&thn=${current.year}&crc=${crc}&tipe_data=${dataType}${extra}`;

      window.open(url, "_blank");
    }
  }
}
</script>
